import { Accordion, AccordionItem } from '../components/accordion/accordion';
import ActionBar from '../components/action-bar/action-bar';
import AnimatedLogo from '../components/animated-logo/javascripts/index';
import Animation from '../components/animation/animation';
import ArticleStage from '../components/article-stage/article-stage';
import AuthorStage from '../components/author-stage/author-stage';
import Button from '../components/button/button';
import Christmascard from '../components/christmascard/christmascard';
import ContactForm from '../components/contact-form/contact-form';
import ContentBlocks from '../components/content-blocks/content-blocks';
import Dialog from '../components/dialog/javascripts/index';
import DownloadForm from '../components/download-form/download-form';
import EventTeaser from '../components/event-teaser/event-teaser';
import Footer from '../components/footer/footer';
import Form from '../components/form/javascripts/index';
import Gallery from '../components/gallery/javascripts/index';
import Header from '../components/header/javascripts/header';
import HeroTeaser from '../components/hero-teaser/hero-teaser';
import InfoCards from '../components/info-cards/javascripts/index';
import InlineTeaser from '../components/inline-teaser/inline-teaser';
import MainStage from '../components/main-stage/main-stage';
import Marquee from '../components/marquee/marquee';
import Navigation from '../components/navigation/navigation';
import PhotoWall from '../components/photo-wall/photo-wall';
import Quote from '../components/quote/quote';
import ScrollContainer from '../components/scroll-container/javascripts/index';
import ScrollInfo from '../components/scroll-info/scroll-info';
import Search from '../components/search/search';
import SearchDialog from '../components/search-dialog/search-dialog';
import Section from '../components/section/section';
import Stage from '../components/stage/stage';
import StandardTeaser from '../components/standard-teaser/standard-teaser';
import SuccessStoryStage from '../components/success-story-stage/success-story-stage';
import SuccessStoryTeaser from '../components/success-story-teaser/success-story-teaser';
import TeaserGrid from '../components/teaser-grid/teaser-grid';
import TeaserSlider from '../components/teaser-slider/teaser-slider';
import Tooltip from '../components/tooltip/tooltip';
import Video from '../components/video/javascripts/index';
import VideoStage from '../components/video-stage/video-stage';
import { HeroesComicItem } from '../components/heroes-comic/heroes-comic';

// Heroes Campaign
import HeroesTopicStage from '../components/heroes-topic-stage/heroes-topic-stage';

export default {
  Accordion,
  AccordionItem,
  ActionBar,
  AnimatedLogo,
  Animation,
  ArticleStage,
  AuthorStage,
  Button,
  Christmascard,
  ContactForm,
  ContentBlocks,
  Dialog,
  DownloadForm,
  EventTeaser,
  Footer,
  Form,
  Gallery,
  Header,
  HeroTeaser,
  InfoCards,
  InlineTeaser,
  MainStage,
  Marquee,
  Navigation,
  PhotoWall,
  Quote,
  ScrollContainer,
  ScrollInfo,
  Search,
  SearchDialog,
  Section,
  Stage,
  StandardTeaser,
  SuccessStoryStage,
  SuccessStoryTeaser,
  TeaserGrid,
  TeaserSlider,
  Tooltip,
  Video,
  VideoStage,
  HeroesTopicStage,
  HeroesComicItem
};
